import { BorderRadiusAll } from '../../themes/default/borderRadius/index.js';
import { BorderRadiusTokensAll } from '../../themes/default/borderRadius/borderRadius-tokens.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var themeBorderRadius = function themeBorderRadius() {
  var borderRadiusOverrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var themedBorderRadius = _objectSpread({}, BorderRadiusAll);

  var keys = Object.keys(borderRadiusOverrides);
  keys.forEach(function (borderRadiusName) {
    if (Object.keys(BorderRadiusTokensAll).indexOf(borderRadiusName) === -1) {
      if (typeof borderRadiusOverrides[borderRadiusName] === 'number') {
        themedBorderRadius[borderRadiusName] = borderRadiusOverrides[borderRadiusName];
      } else {
        /* eslint-disable no-console */
        console.error("Border Radius override must be a number - ignoring ".concat(borderRadiusName, " override"));
      }
    } else {
      console.error("User may not override Border Radius Tokens: ".concat(Object.keys(BorderRadiusTokensAll), " - ignoring ").concat(borderRadiusName, " override"));
    }
  });
  return themedBorderRadius;
};

export { themeBorderRadius };
